import {
  DefaultEntityFilters,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

export class CustomEntityKindsFilter implements EntityFilter {
  readonly values: string[];
  readonly labels: string[];

  constructor(allowedKinds: string[]) {
    this.values = allowedKinds;
    this.labels = [`Kind: ${allowedKinds.join(', ')}`];
  }

  get allowedKinds(): string[] {
    return this.values;
  }

  getCatalogFilters(): Record<string, string | string[]> {
    return { kind: this.allowedKinds };
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

export type CustomEntityFilters = DefaultEntityFilters & {
  kinds?: CustomEntityKindsFilter;
};
